import {addCircularTabFocus, focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useAppActions} from '../../../../../hooks/runtime'
import {StyledButton} from '../../styled-button'
import {classes} from '../error-modal.st.css'

export const SomethingWentWrong = () => {
  const {t} = useTranslation()
  const {isMobile} = useEnvironment()
  const {checkout, clearReservationError} = useAppActions()

  React.useEffect(() => {
    focusElement({selector: hookToAttributeSelector(DH.MODAL_TITLE)})
    addCircularTabFocus(hookToAttributeSelector(DH.CLOSE_BUTTON), hookToAttributeSelector(DH.TRY_AGAIN_BUTTON))
  }, [])

  return (
    <div role="dialog" aria-modal="true" className={classes.container}>
      <div className={classNames(classes.content, {[classes.desktopContent]: !isMobile})}>
        <div className={classes.text}>
          <Text
            data-hook={DH.MODAL_TITLE}
            tagName="h2"
            className={classNames(classes.title, {[classes.mobileTitle]: isMobile})}
          >
            {t('seatings_somethingWentWrongModal_title')}
          </Text>
        </div>
        <div className={classes.buttonContainer}>
          <StyledButton
            dataHook={DH.CLOSE_BUTTON}
            fullWidth={false}
            secondary={true}
            onClick={() => clearReservationError()}
          >
            {t('seatings_somethingWentWrongModal_closeButton')}
          </StyledButton>
          <StyledButton dataHook={DH.TRY_AGAIN_BUTTON} fullWidth={false} onClick={() => checkout()}>
            {t('seatings_somethingWentWrongModal_tryAgainButton')}
          </StyledButton>
        </div>
      </div>
    </div>
  )
}
